import { Component, OnInit, Input, ChangeDetectorRef, ViewChildren, isDevMode, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PromptModalComponent } from '../../prompt-modal/prompt-modal.component';
import { FirebaseService } from 'src/app/service/firebase.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { QuizOptionsComponent } from 'src/app/modals/quiz-options/quiz-options.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';
import { SharedService } from 'src/app/services/shared.service';
import { ModalMainComponent } from '../../modals/modal-main/modal-main.component';
import { ModalUploadBackgroundComponent } from '../../modals/modal-upload-background/modal-upload-background.component'
import { MatSelect } from '@angular/material/select';
import { TranslationPipe } from '../../shared/pipes/translation.pipe';
import { ModalTextComponent } from '../../modals/modal-text/modal-text.component';
import { MatExpansionModule } from '@angular/material/expansion';
@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit, AfterViewInit {

  group: string;
  device: string;
  user: any;
  @ViewChildren('mat-select') selectDropdown: MatSelect;
  @ViewChild('addQuestionContainer') addQuestionHTMLElement: ElementRef;
  startTextPosition: any;
  endTextPosition: any;
  isAvailable: boolean = false;
  constructor(
    public dialog: MatDialog,
    private firebaseService: FirebaseService,
    private _ref: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    public sharedService: SharedService,
    public translation: TranslationPipe
  ) {
    this.group = this.sharedService.selectedDevice.data.group;
    this.device = this.sharedService.selectedDevice.data.name;
    this.user = this.firebaseService.getLocalUser();
    console.log(this.user)
  }



  dialogRef: any;
  idModule: any;
  openedQuestionId: string = null;


  listQuiz: any = [];
  questionList: any = [];
  selectedQuiz: any = {};
  selectedQuizName: string;
  private hasBeenVisible = false;
  private latestUpdateType: string = null;
  questionType: Array<{ name: string, key: string, authorizedUid?: Array<string> }> = [
    {
      name: 'text',
      key: 'textfield'
    },
    {
      name: 'qcm',
      key: 'qcm'
    }, {
      name: 'signature',
      key: 'signature',
      authorizedUid: [

      ]
    }
    , {
      name: 'list',
      key: 'list',
      authorizedUid: [
        '9lOKnEVpClcxibWJsORtzKQLbHt2',
        'TW0LZKlTEkPeU2up4L462QVlWtk1'
      ]
    }

  ]
  questionsDocs: any;
  activeQuiz: string = ''

  quizConfig: any = {};
  uploadEvent: any;
  uploadFolder: any;
  rulesURL: string;
  latestUpdate: any;
  showAddQuestionFloatingButton: boolean = false;
  private observer?: IntersectionObserver;
  quizData: any = {};
  enableRules: boolean;
  listModules: any; //= [];
  private questionDataSub$: any = null;
  selectedQuizData: any;
  isDev: boolean = false;


  authorizedUser: Array<string> = ['3ZvY73Oer0UinEaNdmLMesUCzPt1']


  public defaultVerification: string = "none";


  ngOnInit() {

    this.isDev = isDevMode();
    this.listModules = this.sharedService.selectedDevice.data.modules;
    console.log(this.user)


    if (this.isDev || this.authorizedUser.includes(this.user.uid)) {
      this.isAvailable = true;
    }

    this.firebaseService.getModuleFromDevice('quiz', this.group, this.device).then(d => {
      if (d) {
        this.idModule = d.id;
        this.activeQuiz = d.data.activeQuiz
        this.enableRules = d.data.rulesDisplay
        this.latestUpdate = d.data.latestUpdate
        this.rulesURL = d.data.urlRules
        this.firebaseService.getQuizFromDevice(this.group, this.device, this.idModule).then(d => {
          this.firebaseService.quizModule.subscribe(qData => {
            this.listQuiz = qData;
            this._ref.detectChanges();
          })
        })
      }

    })
  }

  ngAfterViewInit() {

  }

  enableIntersectionObserver() {
    this.observer?.disconnect();
    this.observer = new IntersectionObserver(
      ([entry]) => {

        if (entry.isIntersecting) {
          this.hasBeenVisible = true;
        }

        this.showAddQuestionFloatingButton = !entry.isIntersecting &&
          this.hasBeenVisible;
        console.log("SHOW FLOATING ADD QUESTION", this.showAddQuestionFloatingButton)
      },
      {
        threshold: 1
      }
    );

    this.observer.observe(this.addQuestionHTMLElement.nativeElement);
  }


  checkIfMultiResponse() {
    this.questionList.data.forEach(question => {
      let correctResponse = 0;
      question.response.forEach(response => {
        if (response.correct)

          correctResponse++;
      })

      if (correctResponse > 1)
        question.multi = true;
      else
        question.multi = false;
    })
  }

  setCorrectResponse(response, responseList, val) {
    /* if (!this.quizData.activeScore) {
       response.correct = val;
     }
     else {
       responseList.forEach(elem => {
         elem.correct = false;
       })
       */
    response.correct = val;
    //}




    this.saveQuiz();
  }

  /**
   * Upload files
   * @param e Input[type=file] event
   * @param folder The folder name
   */
  uploadFiles(e, folder) {


    this.firebaseService.uploadFiles(e.target.files, folder).then(data => {
      this.firebaseService.updateConfigModule({ urlRules: data[0].url, latestUpdate: this.latestUpdate }, this.idModule)
      this.rulesURL = data[0].url;
    }).catch(err => {
      console.log(err)
    })
  }

  /**
   * Update rules display in module's config
   * @param value Boolean
   */
  activeRules(value) {
    this.firebaseService.updateConfigModule({ rulesDisplay: value, latestUpdate: this.latestUpdate }, this.idModule).then(d => {
      this.latestUpdate = d;
    })
  }

  /**
   * Scroll to the end of the page
   * */
  scrollToEndPage() {
    window.scrollTo(0, document.body.scrollHeight)
  }


  /**
   * Change the validation on the field and save the quiz
   * @param item 
   * @param value
   */

  selectChange(item, value) {
    let selected = value.source.selected.value;

    if (selected != " ") {
      item.required = true;
    }
    this.saveQuiz()
  }

  /**
   * Add new question to config
   * @param type The question's type.
   */
  addQuestion(type) {

    console.log("ADD QUESTION TYPE:", type)
    let priority = this.questionList.id.length;
    if (!priority)
      priority = 0;
    let data = { type: type, label: '', multi: false, required: false, response: [], idQuiz: this.selectedQuiz, priority: priority, validation: ' ' };

    this.saveQuiz();
    this.firebaseService.addQuestion(data, this.group, this.device)
    this.latestUpdateType = 'add'

    //     this.setOpenedQuestionId(this.questionList.id.at(-1))


  }


  goToQuestion(id: number) {
    setTimeout(() => {
      let index = this.questionList.id.findIndex(v => v == id);
      let element = document
        .getElementById(`question-${index}`)
      let headerOffset = 100;
      let elementPosition = element.getBoundingClientRect().top;
      let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      console.log(offsetPosition)

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }, 300)
    console.log(this.openedQuestionId)
  }


  /**
   * Remove question
   * @param id The question's id
   */
  removeQuestion(id) {

    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '70vw',
      height: '30vh',
      maxWidth: '500px',
      data: {
        title: this.translation.transform('warningDeleteQuestion')
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.firebaseService.deleteQuestion(id).then(d => {


          this.questionList.data.forEach((item, index) => {
            item.priority = index;
            console.log(this.questionList, index)
          })

          this.latestUpdateType = 'delete'
          this.saveQuiz();
        });
      }
    })





  }


  /**
   * Get quiz data from service
   * @param id The quiz's id
   */
  getQuizData(id) {
    console.log("GET QUIZ DATA ID", id)
    //this.firebaseService.questionsData.unsubscribe();
    if (this.questionDataSub$) {
      this.questionDataSub$.unsubscribe();
      this.questionDataSub$ = null;
    }
    this.firebaseService.getQuestionFromQuiz(id).then(d => {

      if (!this.questionDataSub$)
        this.questionDataSub$ = this.firebaseService.questionsData.subscribe(d => {
          this.questionList = (d);
          this.selectedQuiz = id;

          console.log(this.questionList, this.selectedQuiz)

          if (this.latestUpdateType == 'add') {
            this.setOpenedQuestionId(this.questionList.id.at(-1))
            this.latestUpdateType = null;
          }

          this.questionList.data.forEach((question, index) => {

            question.priority = index;

            if (!question.sendEmailToResponse)
              question.sendEmailToResponse = { enable: false, object: ``, content: `` }

            if (question.displayLabel == undefined)
              question.displayLabel = true;


            /*  if (question.response.length > 0) {
                question.map(v => {
                  if(!v.)
                })
              }*/


          })
          setTimeout(() => {
            this.enableIntersectionObserver();
          }, 100)

        })
    });


    this.firebaseService.getQuizData(id).then(d => {

      this.quizData = d.data();

      console.log(this.quizData)
      if (!this.quizData.startTextPosition)
        this.quizData.startTextPosition = 'center';
      if (!this.quizData.endTextPosition)
        this.quizData.endTextPosition = 'center'

      if (!this.quizData.welcomeBackground)
        this.quizData.welcomeBackground = { "name": '', "url": '' };
      if (!this.quizData.thanksBackground)
        this.quizData.thanksBackground = { "name": '', "url": '' };

      // console.log(this.quizData)
      if (this.quizData.questionPoint == undefined || this.quizData.questionPoint == 0)
        this.quizData.questionPoint = 1;
    })


  }

  /**
   * Add response to local question array
   * @param id The local quesion's id
   */
  addResponse(id) {

    this.questionList.id.forEach((item, index) => {
      if (id == item)
        this.questionList.data[index].response.push({ label: '', answer: false, jump_to: '' })
    })


  }

  setSeveralResponseValue(val) {
    if (this.quizData.activeScore) {
      return false
    }
    else
      return val;
  }



  updateQuizState() {

    console.log(this.questionList)



    if (!this.quizData.emailList || this.quizData.emailList.length == 0)
      this.quizData.enableEmail = false;

    if (this.quizData.randomizeQuestion && !this.quizData.nbLimitQuestion)
      this.quizData.nbLimitQuestion = this.questionList.data.length;

    console.log(parseInt(this.quizData.nbLimitQuestion))
    if (typeof this.quizData.nbLimitQuestion == "string")
      this.quizData.nbLimitQuestion = parseInt(this.quizData.nbLimitQuestion)


    if (parseInt(this.quizData.nbLimitQuestion) <= 0)
      this.quizData.nbLimitQuestion = 1;

    if (parseInt(this.quizData.nbLimitQuestion) > this.questionList.data.length)
      this.quizData.nbLimitQuestion = this.questionList.data.length;
    /*  this.questionList.data.forEach(question => {
   
        let correctResp = [];
   
        question.response.forEach((resp) => {
          if (resp.correct)
            correctResp.push(resp);
        })
   
        if (correctResp.length > 1) {
          for (let i = 1; i < correctResp.length; i++)
          {
            question.response[question.response.indexOf(correctResp[i])].correct = false;
          }
      }
   
        console.log(question)
      })
      */

    this.saveQuiz();
  }

  /**
   * Call save quiz from service
   * */
  saveQuiz() {


    let currentQuizData = JSON.parse(JSON.stringify(this.quizData));



    console.log(this.selectedQuiz, JSON.parse(JSON.stringify( currentQuizData)))
    this.firebaseService.getQuizData(this.selectedQuiz).then(d => {

      /*  let localDate;
   
   
          let distantDate = new Date(currentQuizData.latestUpdate.seconds * 1000 + currentQuizData.latestUpdate.nanoseconds / 1000000)//.toUTCString()
          if (currentQuizData.latestUpdate.seconds)
            localDate = new Date(this.latestUpdate.seconds * 1000 + this.latestUpdate.nanoseconds / 1000000)//.toUTCString()
          else
            localDate = new Date(this.latestUpdate)
          if (localDate.toString() != distantDate.toString()) {
   
            this.dialogRef = this.dialog.open(ModalTextComponent, {
              data: 'Une version plus récente des données est déjà enregistré, veuillez recharger les données.'
            })
            /* TRIGGER MODAL 
   
   
          }
          else {*/
      //  this.quizData.latestUpdate = new Date();
      // this.latestUpdate = this.quizData.latestUpdate
      this.questionList.id.forEach((item, index) => {
        this.firebaseService.updateQuestion(item, this.questionList.data[index])
      })

      this.firebaseService.updateConfigModule({ latestUpdate: this.latestUpdate }, this.idModule).then(d => {
        this.latestUpdate = d;

        this.firebaseService.updateActiveQuiz(this.selectedQuiz, this.quizData);


        if (this.sharedService.selectedDevice.data.modules.media) {
          this.firebaseService.sendUpdateToMedia(this.sharedService.selectedDevice.data.group, this.sharedService.selectedDevice.data.name)
          // this.firebaseService.changeWebviewMediaModule(this.oldConfig.urlConfig[res.index], this.device, this.group, newConfig)
        }
      })
      //   }





    })





    //this.quizData.latestUpdate = new Date();
    this.checkIfMultiResponse();

    /* this.questionList.data.forEach((item) => {
       if (this.quizData.activeScore && item.type == 'qcm') {
         item.multi = false;
       }
     })*/











    /*
  
  */

  }





  /**
   * Call prompt modal and create quiz with name from result
   * */
  createQuiz() {
    this.dialogRef = this.dialog.open(PromptModalComponent, {
      width: '70vw',
      height: '30vh',
      maxWidth: '500px',
      data: { title: this.translation.transform('enterQuizName') }
    })

    this.dialogRef.afterClosed().subscribe(result => {

      //console.log(result, this.device, this.group, this.idModule)
      if (result) {
        this.firebaseService.addQuiz(result, this.device, this.group, this.idModule).then(d => {
          if (this.activeQuiz == undefined || this.activeQuiz.length <= 0)
            this.activeQuiz = d.id;
          this.firebaseService.updateActiveQuizInModule(this.activeQuiz, this.idModule)

          //   console.log(this.selectedQuiz)


        })
      }
    });
  }


  /*onQuizOptionsClick() {
    this.dialogRef = this.dialog.open(QuizOptionsComponent, {
      width: '70vw',
      height: '30vh',
      maxWidth:'500px',
      data: { title: 'Voulez-vous supprimer ce quiz ?' }
    })
  
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == "edit") {
      }
    });
  }*/


  /**
   * Duplicate the quiz data, not the medias
   * @param id The quiz'id
   */

  duplicateQuiz(quizIndex: string) {
    let selectedDuplicateQuiz = { id: this.listQuiz.id[quizIndex], data: this.listQuiz.data[quizIndex] }

    console.log(selectedDuplicateQuiz)





    this.firebaseService.getQuestionFromQuiz(selectedDuplicateQuiz.id).then(questions => {
      console.log(selectedDuplicateQuiz, questions)


      this.firebaseService.duplicateQuiz(selectedDuplicateQuiz.id, selectedDuplicateQuiz.data, questions)
    })

  }


  /**
   * Open confirm modal for deleting a quiz
   * @param e The quiz's id 
   */
  removeQuiz(e: any) {

    if (this.activeQuiz != e) {


      this.dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '70vw',
        height: '30vh',
        maxWidth: '500px',
        data: {
          title: this.translation.transform('warningDeleteQuiz')
        }
      })

      this.dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.firebaseService.deleteQuiz(e);
          this.selectedQuiz = null;
        }
      });
    }
    else {
      this.snackBar.open(this.translation.transform('warningActiveQuizDelete') as string, 'OK', { duration: 3000 })
    }

  }

  addListItem(val, index) {
    console.log(val, index)

    console.log(this.questionList.data[index])
    if (!this.questionList.data[index].listItems) {
      this.questionList.data[index].listItems = [];
    }

    this.questionList.data[index].listItems.push(val);

    this.saveQuiz();
  }

  addEmail(val) {

    //console.log(val)


    if (!this.quizData.emailList)
      this.quizData.emailList = [];


    if (this.quizData.emailList.includes(val)) {
      this.snackBar.open(`${this.translation.transform('emailAlreadyUsed')}`)
      return;
    }

    if (this.quizData.length >= 5) {
      this.snackBar.open(`${this.translation.transform('tooManyEmailSaved')}`)
      return;
    }
    this.quizData.emailList.push(val)
    this.updateQuizState();
  }


  deleteEmailFromList(i) {
    this.quizData.emailList.splice(i, 1);

    this.updateQuizState();
  }

  deleteItemFromList(i, indexI) {
    this.questionList.data[i].listItems.splice(indexI, 1);
    this.saveQuiz();
  }

  updateItemFromList(i, index) {
    console.log(this.questionList.data[i].listItems[i])

    var _data = {

      type: 'text',
      title: this.translation.transform('enterNewName'),
      buttonLabel: this.translation.transform('validate'),
      currentValue: this.questionList.data[i].listItems[index],//elem.name.split('.')[elem.name.split('.').length - 1],
      buttonColor: 'accent',

    };
    //  elemLang: 

    this.dialogRef = this.dialog.open(ModalMainComponent, {

      height: '50vh',
      data: _data
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result)

        this.questionList.data[i].listItems[index] = result.currentValue

        console.log(this.questionList.data[i].listItems)
        this.saveQuiz();
      }

    })
  }

  showColorModal(val, type) {




    let _data = {
      type: 'color',
      title: this.translation.transform('colorTextDisplay'),
      currentValue: val,
      buttonLabel: this.translation.transform('validate'),
      buttonColor: 'accent'
    }



    this.dialogRef = this.dialog.open(ModalMainComponent, {

      height: '350px',
      data: _data
    })


    this.dialogRef.afterClosed().subscribe(result => {

      if (result) {
        if (type == 'text') {
          this.quizData.colorText = result.currentValue
        }
        else if (type == 'background') {
          this.quizData.colorBackground = result.currentValue;
        }
        else if (type == 'button') {
          this.quizData.colorButton = result.currentValue;
        }
        else if (type == 'textButton') {
          this.quizData.colorTextButton = result.currentValue
        }
        this.saveQuiz();
      }
    });
  }

  uploadElement(e, type) {


    //console.log(e, type)
    this.dialogRef = this.dialog.open(ModalUploadBackgroundComponent, {
      width: '300px',
      height: '300px',
      data:
      {
        title: this.translation.transform('importMedia')
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.sharedService.uploadEvent = result;
        this.sharedService.uploadFolder = 'media';

        console.log(type)

        //console.log(e, type, result)

        this.firebaseService.uploadFiles(result.target.files, 'media').then(d => {

          if (type == 'media') {
            if (e.urlMedia && e.urlMedia.length > 0)
              this.firebaseService.removeFileFromUrl(e.urlMedia);

            e.urlMedia = d[0].url;
            e.nameMedia = d[0].data.name
          }


          else if (type == 'background') {
            if (e.urlBackground && e.urlBackground.length > 0)
              this.firebaseService.removeFileFromUrl(e.urlBackground);

            e.urlBackground = d[0].url;
            e.nameBackground = d[0].data.name
          }


          else if (type == 'backgroundSettingsWelcome') {
            if (this.quizData.welcomeBackground && this.quizData.welcomeBackground.url && this.quizData.welcomeBackground.url.length > 0)
              this.firebaseService.removeFileFromUrl(this.quizData.welcomeBackground.url)

            this.quizData.welcomeBackground.name = d[0].data.name;
            this.quizData.welcomeBackground.url = d[0].url;
          }
          else if (type == 'backgroundSettingsThanks') {
            if (this.quizData.thanksBackground && this.quizData.thanksBackground.url.length > 0)
              this.firebaseService.removeFileFromUrl(this.quizData.thanksBackground.url)
            this.quizData.thanksBackground.name = d[0].data.name;
            this.quizData.thanksBackground.url = d[0].url;
          }
          else if (type == 'response') {
            if (e.ques.response[e.respInd].img && e.ques.response[e.respInd].img.url)
              this.firebaseService.removeFileFromUrl(e.ques.response[e.respInd].img.url)

            e.ques.response[e.respInd].img = { name: d[0].data.name, url: d[0].url };
          }
          else if (type == 'responseBackground') {
            if (e.ques.response[e.respInd].endUrlMediaendUrlMedia && e.ques.response[e.respInd].endUrlMedia.url)
              this.firebaseService.removeFileFromUrl(e.ques.response[e.respInd].endUrlMedia.url)

            e.ques.response[e.respInd].endUrlMedia = { name: d[0].data.name, url: d[0].url };

          }
          this.saveQuiz();

          this.sharedService.uploadEvent = null;
          this.sharedService.uploadFolder = null;
        })

        /*this.sharedService.submit().then(d => {
          if (this.sharedService.configForm.backgroundURL == undefined || this.sharedService.configForm.backgroundURL.length <= 0) {
            this.sharedService.configForm.backgroundURL = this.sharedService.configForm.listBackgrounds[0]
            this.sharedService.submit();
          }
  
          this.sharedService.setMetadateFromImage();
        });*/
      }

    });
  }

  deleteQuizMediaElement(e) {

    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '70vw',
      height: '30vh',
      maxWidth: '500px',
      data: {
        title: this.translation.transform('warningDeleteMedia')
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.firebaseService.removeImg(e.urlMedia)
        e.urlMedia = null;
        e.nameMedia = null;

        this.saveQuiz();
      }
    });




  }



  deleteQuizBackgroundElement(e) {
    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '70vw',
      height: '30vh',
      maxWidth: '500px',
      data: {
        title: this.translation.transform('warningDeleteMedia'),
        type: 'mediaBackground'
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.firebaseService.removeImg(e.urlBackground)
        e.urlBackground = null;
        e.nameBackground = null;

        this.saveQuiz();
      }
    });
  }

  deleteQuizResponseEndMedia(e, id) {
    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '70vw',
      height: '30vh',
      maxWidth: '500px',
      data: {
        title: this.translation.transform('warningDeleteMedia'),
        type: 'mediaBackground'
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(e)

        //console.log(e, id)

        this.firebaseService.removeImg(e.response[id].endUrlMedia.url)


        e.response[id].endUrlMedia = { name: '', url: '' };
        this.saveQuiz();
      }
    });
  }

  deleteQuizResponseMedia(e, id) {
    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '70vw',
      height: '30vh',
      maxWidth: '500px',
      data: {
        title: this.translation.transform('warningDeleteMedia'),
        type: 'mediaBackground'
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {


        //console.log(e, id)

        this.firebaseService.removeImg(e.urlBackground)


        e.response[id].img = { name: '', url: '' };
        this.saveQuiz();
      }
    });
  }

  deleteQuizSettingsBackgroundElement(e) {
    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '70vw',
      height: '30vh',
      maxWidth: '500px',
      data: {
        title: this.translation.transform('warningDeleteMedia'),
        type: 'mediaBackground'
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.firebaseService.removeImg(e.url)
        e.url = '';
        e.name = '';
        this.saveQuiz();
      }
    });
  }




  applyToAllGroup() {
    //console.log(this.listQuiz)


    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('confirmOperation'), ok: 'OK', cancel: this.translation.transform('cancel') }
    })


    this.dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.firebaseService.updateQuizSettingsOfAllGroup(this.listQuiz, this.sharedService.selectedDevice.data.group, this.sharedService.selectedDevice.data.name, this.idModule, { activeRules: this.enableRules, rulesURL: this.rulesURL, activeQuiz: this.activeQuiz })

      }

      else {

      }

    })




  }

  addEndMessage(quizData) {



    if (quizData.endMessages == undefined || quizData.endMessages.length == 0) {
      quizData.endMessages = [];

      //console.log("EMPTY QUIZ DATA")
      quizData.endMessages.push({ min: 0, max: 0, message: '' })
    }
    else if (quizData.endMessages.length > 0) {
      //console.log("NOT EMPTY QUIZ DATA")
      quizData.endMessages.push({ min: parseInt(quizData.endMessages[quizData.endMessages.length - 1].max) + 1, max: parseInt(quizData.endMessages[quizData.endMessages.length - 1].max) + 1, message: '' })
    }
    //console.log("ADD END MESSAGE", quizData.endMessages)
  }

  checkEndMessageValue(elem, i, type, newVal) {

    // console.log(newVal)
    // let value = elem.target.value
    //  let exist = false;
    if (type == 'min')
      i.min = parseInt(newVal);
    if (type == 'max')
      i.max = parseInt(newVal);




    // console.log(this.quizData.endMessages, elem, type, i);
    // console.log(this.quizData.endMessages)







    let tmp = JSON.parse(JSON.stringify(this.quizData.endMessages))




    for (let i = 0; i < tmp.length; i++) {
      if (tmp[i - 1] != undefined) {
        if (tmp[i - 1].max >= tmp[i].min)
          tmp[i].min = tmp[i - 1].max + 1;
      }
    }




    tmp.forEach((item) => {

      if (item.min > item.max) {

        item.max = item.min

      }

    })

    //  this.quizData.endMesssage = tmp;

    /* for (let elem of this.quizData.endMessages) {
       let tmp = this.quizData.endMessages[elem]
       console.log(elem)
     }*/

    /* for (let i = 0; i < this.quizData.endMessages.length; i++) {
   
        console.log(this.quizData.endMessages[i - 1])
        if (this.quizData.endMessages[i - 1] != undefined) {
   
          console.log(this.quizData.endMessages[i - 1].max, this.quizData.endMessages[i].min)
          if (this.quizData.endMessages[i - 1].max != this.quizData.endMessages[i].min) {
            this.quizData.endMessages[i].min = this.quizData.endMessages[i - 1].max
          }
   
        }
      }*/

    /* console.log(item, value)
     if (item.min == value || item.max == value)
       exist = true;
  
     console.log(item.min, item.max)
     if (parseInt(item.min) > parseInt(item.max)) {
       item.max = item.min;
  
       console.log(item.min, item.max, elem)
       elem.target.setAttribute('value', ""+item.max)
     //  elem.target.value = ""+item.max;
     }
  
   })
  
   quizData.endMessages.forEach((item, index) => {
     if (index == i) {
       item[type] = parseInt(value);
     }
   })
  
   */
    /*  if (exist) {
        console.log("VALUE ALREADY USED")
      }
      else {
   
   
   
        console.log("VALUE NOT USED", quizData)
       // this.quizData.endMessages = endMessages
        this.saveQuiz();
      }*/
    //  this._ref.detectChanges();
    //  console.log(tmp)
    this.quizData.endMessages = tmp;
    this.saveQuiz();
  }

  removeEndMessageElement(quizData, i) {
    quizData.endMessages.splice(i, 1)

    this.saveQuiz();
  }

  renameQuiz(e) {
    this.dialogRef = this.dialog.open(PromptModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('enterQuizName') }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.firebaseService.updateQuiz(e, { name: result })

        if (this.sharedService.selectedDevice.data.modules.media) {
          this.firebaseService.changeQuizMediaModule(e, { name: result });
          //this.firebaseService.changeWebviewMediaModule(this.oldConfig.urlConfig[res.index], this.device, this.group, newConfig)
        }
        /* this.firebaseService.deleteQuiz(e);
         this.selectedQuiz = null;*/
      }
    })
  }



  /**
   * Remove response in local question array
   * @param indexQ The question's id
   * @param indexR The reponses's id
   */
  removeResponse(indexQ, indexR) {

    this.questionList.data[indexQ].response.splice(indexR, 1)
    this.saveQuiz();
  }

  /**
   * Set active quiz
   * @param quiz The quiz new data
   */
  setActiveQuiz(quiz) {

    this.activeQuiz = quiz;
    this.firebaseService.updateActiveQuizInModule(quiz, this.idModule);
  }

  changePriority(oldpriority, newpriority, select) {

    //console.log(oldpriority, newpriority)
    //console.log(this.questionList, this.questionList.data)
    /* this.questionList.forEach((item) => {
       console.log(item)
     })*/

    //  function array_move(arr, old_index, new_index) {
    if (newpriority >= this.questionList.data.length) {
      var k = newpriority - this.questionList.data.length + 1;
      while (k--) {
        this.questionList.data.push(undefined);
      }
    }
    this.questionList.data.splice(newpriority, 0, this.questionList.data.splice(oldpriority, 1)[0]);




    this.questionList.data.forEach((item, index) => {
      item.priority = index;
    })
    //    return arr; // for testing
    // };

    // returns [2, 1, 3]
    //  console.log(array_move([1, 2, 3], 0, 1)); 


    //console.log("OLD", oldpriority, "NEW", newpriority)
    //console.log(this.questionList.data, select)
    select.source.value = [];
    this._ref.detectChanges();
    this.saveQuiz();
  }

  /**
   * Manage the drag and drop of question, update quiz in Firestore
   * @param event
   */
  drop(event: CdkDragDrop<string[]>) {
    let id = event.item.element.nativeElement.dataset.questionid;

    let curIndex;
    this.questionList.id.forEach((item, index) => {
      if (item == id)
        curIndex = index;
    })

    let tmpId = this.questionList.id[event.previousIndex]
    let tmpData = this.questionList.data[event.previousIndex]

    this.questionList.id[event.previousIndex] = this.questionList.id[event.currentIndex]
    this.questionList.data[event.previousIndex] = this.questionList.data[event.currentIndex]

    this.questionList.data[event.previousIndex].priority = event.previousIndex


    this.questionList.id[event.currentIndex] = tmpId;
    this.questionList.data[event.currentIndex] = tmpData;

    this.questionList.data[event.currentIndex].priority = event.currentIndex;

    this.saveQuiz();
  }

  /**
   * Upload image on quiz/rules
   * */
  onUploadImage() {
    this.dialogRef = this.dialog.open(ModalUploadBackgroundComponent, {
      width: '300px',
      height: '300px',
      data:
      {
        title: this.translation.transform('importRules')
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.uploadFiles(result, 'quiz/rules')

      }
    })
  }


  /**
   * Open modal
   * @param s The modal's type
   * @param value The field's value
   */
  showModal(s: string, value: string) {


    var _data = {};

    switch (s) {
      case 'welcomeText':
        _data = {
          type: 'text',
          title: this.translation.transform('changeWelcomeText'),
          currentValue: value,
          buttonLabel: this.translation.transform('change'),
          buttonColor: 'warn'
        }
        break;

      case 'goodByeText':
        _data = {
          type: 'text',
          title: this.translation.transform('changeGoodbyeText'),
          currentValue: value,
          buttonLabel: this.translation.transform('validate'),
          buttonColor: 'accent'
        }
        break;

      default:
        break;

    }


    this.dialogRef = this.dialog.open(ModalMainComponent, {

      height: '350px',
      data: _data
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {

        switch (s) {
          case 'welcomeText':
            this.quizData.startText = result.currentValue;
            break;

          case 'goodByeText':
            this.quizData.endText = result.currentValue
            break;
          default:
            break;

        }



        this.saveQuiz();

      }

    });

  }





  setOpenedQuestionId(item) {
    console.log(item)
    this.openedQuestionId = item;
    //  setTimeout(() => {
    this.goToQuestion(item)
    // }, 100)
  }
}
